
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import LanguageIcon from '@mui/icons-material/Language';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import { Snowshoeing } from '@mui/icons-material';
import StyleIcon from '@mui/icons-material/Style';
import CelebrationIcon from '@mui/icons-material/Celebration';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import TtkList from './TtkList';
const GiftsTTK = ({ data }) => {
    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p ><AutoFixHighIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b> Starting Price :</b>&nbsp;<span> {data?.PiecePrice}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <LanguageIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Delivering In :</b>&nbsp;<TtkList data={data?.areaOfWorking} /></p>
                        </div>

                    </div>
                    <div className='row mb-2'>
                        <div className=''>
                            <p> <CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Gifts Type :</b>&nbsp;<TtkList data={data?.favourGifts} /></p>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default GiftsTTK